/**
 * Theme preview blocks Shopify checkout. Redirect to the live storefront URL
 * (same locale, no preview_theme_id) so Arabic/English checkout works while testing.
 */
(function () {
  function isThemePreview() {
    if (window.ShopifyPreviewCheckoutDisabled) return false;
    if (window.Shopify?.designMode) return true;
    if (window.themePreview === true) return true;
    if (new URLSearchParams(window.location.search).has("preview_theme_id")) {
      return true;
    }
    return Boolean(document.querySelector("#preview-bar-iframe, .shopify-preview-bar"));
  }

  function liveCheckoutUrl(path) {
    const checkoutPath =
      path || window.routes?.checkout_url || `${window.Shopify?.routes?.root || "/"}checkout`;
    const url = new URL(checkoutPath, window.location.origin);

    url.searchParams.delete("preview_theme_id");
    url.searchParams.delete("pb");
    url.searchParams.delete("_fd");
    url.searchParams.delete("oseid");

    return url.href;
  }

  function redirectToLiveCheckout(event) {
    if (!isThemePreview()) return false;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    window.location.assign(liveCheckoutUrl());
    return true;
  }

  function bindCheckoutHandlers() {
    if (!isThemePreview()) return;

    document.querySelectorAll('[name="checkout"]').forEach((button) => {
      if (button.dataset.previewCheckoutBound === "true") return;
      button.dataset.previewCheckoutBound = "true";
      button.addEventListener("click", redirectToLiveCheckout, true);
    });

    ["cart-form", "CartDrawer-Form", "cart-notification-form"].forEach((id) => {
      const form = document.getElementById(id);
      if (!form || form.dataset.previewCheckoutBound === "true") return;
      form.dataset.previewCheckoutBound = "true";

      form.addEventListener(
        "submit",
        (event) => {
          const submitter = event.submitter;
          if (submitter?.name === "checkout" || submitter?.classList?.contains("cart-mobile-sticky__checkout")) {
            redirectToLiveCheckout(event);
          }
        },
        true,
      );
    });
  }

  window.PreviewCheckout = {
    isThemePreview,
    liveCheckoutUrl,
    redirectToLiveCheckout,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindCheckoutHandlers);
  } else {
    bindCheckoutHandlers();
  }

  document.addEventListener("shopify:section:load", bindCheckoutHandlers);
})();
